import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';

import { SidebarComponent } from '../../components/sidebar/sidebar.component';

import { NavbarComponent } from '../../components/navbar/navbar.component';

import { ProductService } from '../../core/services/product.service';

import { CategoryService } from '../../core/services/category.service';

import { Product } from '../../models/product.interface';

import { Category } from '../../models/category.interface';
import { SubCategory } from '../../models/sub-category.interface';
import { SubCategoryService } from '../../core/services/sub-category.service';



@Component({

  selector: 'app-product-list',

  standalone: true,

  imports: [CommonModule, RouterModule, FormsModule, SidebarComponent, NavbarComponent],

  template: `

    <app-sidebar></app-sidebar>

    <app-navbar pageTitle="Products" pageSubtitle="Manage Shell Muze phone case catalog & inventory"></app-navbar>



    <div class="page-wrapper">

      <main class="main-content animate-in">



        <!-- FILTER BAR -->

        <section class="filter-bar glass-card">

          <div class="search-field">

            <span class="search-icon">

              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

                <circle cx="11" cy="11" r="8"/>

                <line x1="21" y1="21" x2="16.65" y2="16.65"/>

              </svg>

            </span>

            <input

              type="text"

              class="form-control search-input"

              [(ngModel)]="searchQuery"

              (input)="onSearchInput()"

              placeholder="Search by title, label or badge..."

            />

          </div>



          <div class="filter-controls">
            <select class="form-control filter-select" [(ngModel)]="selectedCategory" (change)="onCategoryFilterChange()">
              <option value="all">All Categories</option>
              <option *ngFor="let cat of categories" [value]="cat.slug">{{ cat.name }}</option>
            </select>

            <select class="form-control filter-select" [(ngModel)]="selectedSubCategory" (change)="onFilterChange()">
              <option value="all">All Sub-Categories</option>
              <option *ngFor="let sub of availableSubCategories" [value]="sub.name">{{ sub.name }}</option>
            </select>



            <select class="form-control filter-select" [(ngModel)]="selectedSort" (change)="onFilterChange()">

              <option value="newest">Newest First</option>

              <option value="price-low">Price: Low → High</option>

              <option value="price-high">Price: High → Low</option>

              <option value="title">Alphabetical A–Z</option>

            </select>



            <!-- Bulk Upload Button -->

           



            <a routerLink="/products/new" class="btn-gold">

              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">

                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>

              </svg>

              Add Product

            </a>

          </div>

        </section>



        <!-- PRODUCTS TABLE CARD -->

        <section class="glass-card table-card">

          <div class="table-card-header">

            <span class="sub-text">

              Showing <strong style="color: var(--text-primary);">{{ getStartIndex() }}-{{ getEndIndex() }}</strong> of <strong style="color: var(--text-primary);">{{ totalProducts }}</strong> products <span *ngIf="totalPages > 1">(Page {{ currentPage }} of {{ totalPages }})</span>

            </span>

          </div>



          <div class="table-wrapper">

            <table class="custom-table">

              <thead>

                <tr>
                  <th>Product</th>
                  <th>Collection</th>
                  <th>Sub-Category</th>
                 
                  <th>Pricing</th>
                  <th>Badge</th>
                  <th>Accent</th>
                  <th>Stock</th>
                  <th>Actions</th>
                </tr>

              </thead>

              <tbody>

                <tr *ngFor="let product of products">

                  <td>

                    <div class="product-cell">

                      <div class="thumb-box" [style.background]="product.bg || '#131C2E'" (click)="openImagePreview(product)" [class.has-multi]="(product.images?.length || 0) > 1" [title]="(product.images?.length || 0) > 1 ? 'Click to see all images' : ''">

                        <!-- Primary image: use images[0] if available, else fallback imageUrl -->

                        <img *ngIf="product.images && product.images.length > 0" [src]="product.images[0].url" [alt]="product.title" />

                        <img *ngIf="(!product.images || product.images.length === 0) && product.imageUrl" [src]="product.imageUrl" [alt]="product.title" />

                        <svg *ngIf="!product.imageUrl && (!product.images || product.images.length === 0)" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="color: var(--text-muted);">

                          <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>

                          <line x1="12" y1="18" x2="12.01" y2="18"/>

                        </svg>

                        <!-- Multi-image count badge -->

                        <div class="img-count-badge" *ngIf="(product.images?.length || 0) > 1">

                          +{{ (product.images?.length || 0) - 1 }}

                        </div>

                      </div>

                      <div>

                        <div class="product-title font-serif">{{ product.title }}</div>

                        <div class="product-label">{{ product.label || 'SHELL MUZE' }}</div>

                        <!-- Image strip (show when multiple images) -->

                        <div class="image-strip" *ngIf="(product.images?.length || 0) > 1">

                          <img

                            *ngFor="let img of (product.images || []).slice(0, 4); let i = index"

                            [src]="img.url"

                            [alt]="'img' + i"

                            class="strip-img"

                            [class.strip-primary]="i === 0"

                          />

                          <span class="strip-more" *ngIf="(product.images?.length || 0) > 4">+{{ (product.images?.length || 0) - 4 }}</span>

                        </div>

                      </div>

                    </div>

                  </td>



                  <td>
                    <span class="badge badge-gold">{{ product.category }}</span>
                  </td>

                  <td>
                    <span *ngIf="product.subCategory" class="badge" style="background: rgba(201,169,110,0.15); color: var(--accent-gold); border: 1px solid rgba(201,169,110,0.3);">
                      {{ product.subCategory }}
                    </span>
                    <span *ngIf="!product.subCategory" class="sub-text" style="color: var(--text-muted); font-size: 11px;">—</span>
                  </td>

                 



                  <td>

                    <div class="price-block">

                      <span class="price-main">₹{{ product.price }}</span>

                      <span class="price-slash" *ngIf="product.slashPrice">₹{{ product.slashPrice }}</span>

                    </div>

                  </td>



                  <td>

                    <span class="badge badge-blue">{{ product.badge || 'Sale' }}</span>

                  </td>



                  <td>

                    <div class="accent-cell">

                      <span class="color-swatch" [style.background]="product.bg || '#18181B'"></span>

                      <span style="font-size: 14px;">{{ product.icon || '✨' }}</span>

                    </div>

                  </td>



                  <td>

                    <button (click)="toggleStock(product)" class="stock-toggle" [class.in-stock]="product.inStock !== false">

                      <span class="stock-dot"></span>

                      {{ product.inStock !== false ? 'In Stock' : 'Out of Stock' }}

                    </button>

                  </td>



                  <td>

                    <div class="action-group">

                      <a [routerLink]="['/products/edit', product._id]" class="btn-secondary btn-icon" title="Edit product">

                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>

                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>

                        </svg>

                      </a>

                      <button (click)="deleteProduct(product)" class="btn-danger btn-icon" title="Delete product">

                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

                          <polyline points="3 6 5 6 21 6"/>

                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>

                          <path d="M10 11v6M14 11v6"/>

                          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>

                        </svg>

                      </button>

                    </div>

                  </td>

                </tr>



                <tr *ngIf="products.length === 0">

                  <td colspan="8">

                    <div class="empty-state">

                      <div class="empty-state-icon">

                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">

                          <circle cx="11" cy="11" r="8"/>

                          <line x1="21" y1="21" x2="16.65" y2="16.65"/>

                        </svg>

                      </div>

                      <h4>No products found</h4>

                      <p>Try adjusting your search or filter criteria</p>

                    </div>

                  </td>

                </tr>

              </tbody>

            </table>

          </div>

          <!-- TABLE PAGINATION FOOTER -->
          <div class="table-pagination-footer" *ngIf="totalProducts > 0">
            <div class="pagination-info">
              <span class="pagination-count">
                Showing <strong>{{ getStartIndex() }}–{{ getEndIndex() }}</strong> of <strong>{{ totalProducts }}</strong> products
              </span>
              <span class="pagination-badge" *ngIf="totalPages > 1">
                Page {{ currentPage }} of {{ totalPages }}
              </span>
            </div>

            <div class="pagination-controls">
              <div class="page-size-selector">
                <span class="page-size-label">Show</span>
                <div class="select-wrapper">
                  <select class="page-size-select" [value]="pageSize" (change)="onPageSizeChange($event)">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / page</option>
                  </select>
                </div>
              </div>

              <div class="page-buttons" *ngIf="totalPages > 1">
                <button class="page-btn nav-btn" [disabled]="currentPage <= 1" (click)="goToPage(1)" title="First Page">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg>
                </button>
                <button class="page-btn nav-btn" [disabled]="currentPage <= 1" (click)="prevPage()" title="Previous Page">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="15 18 9 12 15 6"/></svg>
                </button>

                <ng-container *ngFor="let p of getPageNumbers()">
                  <span *ngIf="p === '...'" class="page-ellipsis">…</span>
                  <button *ngIf="p !== '...'"
                          class="page-btn"
                          [class.active]="p === currentPage"
                          (click)="goToPage(p)">
                    {{ p }}
                  </button>
                </ng-container>

                <button class="page-btn nav-btn" [disabled]="currentPage >= totalPages" (click)="nextPage()" title="Next Page">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="9 18 15 12 9 6"/></svg>
                </button>
                <button class="page-btn nav-btn" [disabled]="currentPage >= totalPages" (click)="goToPage(totalPages)" title="Last Page">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
                </button>
              </div>
            </div>
          </div>

        </section>



      </main>

    </div>



    <!-- IMAGE PREVIEW LIGHTBOX -->

    <div class="img-lightbox-backdrop" *ngIf="previewProduct" (click)="closeImagePreview()">

      <div class="img-lightbox-modal glass-card" (click)="$event.stopPropagation()">

        <div class="lightbox-header">

          <div>

            <h3 class="font-serif">{{ previewProduct.title }}</h3>

            <span class="lightbox-sub">{{ previewProduct.category }} &bull; {{ getPreviewImages().length }} Image{{ getPreviewImages().length > 1 ? 's' : '' }}</span>

          </div>

          <button class="lightbox-close-btn" (click)="closeImagePreview()">&#10005;</button>

        </div>

        <div class="lightbox-main-view">

          <button class="lightbox-nav-btn prev-btn" *ngIf="getPreviewImages().length > 1" (click)="prevPreviewImage()">&#10094;</button>

          <div class="lightbox-img-wrapper" [style.background]="previewProduct.bg || '#131C2E'">

            <img [src]="getPreviewImages()[activePreviewIndex]" [alt]="previewProduct.title" class="lightbox-active-img" />

          </div>

          <button class="lightbox-nav-btn next-btn" *ngIf="getPreviewImages().length > 1" (click)="nextPreviewImage()">&#10095;</button>

        </div>

        <!-- Thumbnails row -->

        <div class="lightbox-thumbs" *ngIf="getPreviewImages().length > 1">

          <div

            *ngFor="let img of getPreviewImages(); let i = index"

            class="lightbox-thumb"

            [class.active]="i === activePreviewIndex"

            (click)="setPreviewIndex(i)"

          >

            <img [src]="img" [alt]="'thumb ' + (i + 1)" />

          </div>

        </div>

      </div>

    </div>



    <!-- BULK UPLOAD MODAL -->

    <div class="bulk-backdrop" *ngIf="bulkModalOpen" (click)="closeBulkModal()">

      <div class="bulk-modal glass-card" (click)="$event.stopPropagation()">



        <!-- Header -->

        <div class="bulk-modal-header">

          <div>

            <h2 class="bulk-modal-title font-serif">

              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">

                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>

                <polyline points="17 8 12 3 7 8"/>

                <line x1="12" y1="3" x2="12" y2="15"/>

              </svg>

              Bulk Upload Products

            </h2>

            <p class="bulk-modal-sub">Upload a CSV file to add multiple products at once (max 500 rows)</p>

          </div>

          <button class="bulk-close-btn" (click)="closeBulkModal()">✕</button>

        </div>



        <!-- ── STEP 1: File picker (no file selected yet) ── -->

        <div *ngIf="!parsedRows.length && !uploadResult">



          <!-- Template Download -->

          <div class="bulk-template-row">

            <span class="bulk-template-label">

              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>

                <polyline points="14 2 14 8 20 8"/>

              </svg>

              New here? Download the CSV template first:

            </span>

            <button class="btn-template" (click)="downloadTemplate()">⬇ Download Template</button>

          </div>



          <!-- Column Guide -->

          <div class="bulk-col-guide">

            <div class="bulk-col-title">Required CSV Columns</div>

            <div class="bulk-col-grid">

              <div class="bulk-col-chip required">title *</div>

              <div class="bulk-col-chip required">price *</div>

              <div class="bulk-col-chip required">category *</div>

              <div class="bulk-col-chip">slashPrice</div>

              <div class="bulk-col-chip">material</div>

              <div class="bulk-col-chip">badge</div>

              <div class="bulk-col-chip">description</div>

              <div class="bulk-col-chip">imageUrl</div>

              <div class="bulk-col-chip">label</div>

              <div class="bulk-col-chip">icon</div>

              <div class="bulk-col-chip">bg</div>

              <div class="bulk-col-chip">inStock</div>

              <div class="bulk-col-chip">featured</div>

              <div class="bulk-col-chip">deviceModels (pipe-separated)</div>

            </div>

            <p class="bulk-note">* Required. <code>deviceModels</code> example: <code>iPhone 16 Pro|Samsung S24</code></p>

          </div>



          <!-- Drop Zone -->

          <div

            class="bulk-dropzone"

            [class.drag-over]="isDragOver"

            (dragover)="$event.preventDefault(); isDragOver = true"

            (dragleave)="isDragOver = false"

            (drop)="onFileDrop($event)"

            (click)="fileInput.click()"

          >

            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="color:var(--accent-gold);margin-bottom:10px">

              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>

              <polyline points="17 8 12 3 7 8"/>

              <line x1="12" y1="3" x2="12" y2="15"/>

            </svg>

            <p class="dropzone-label">Drag & drop your CSV here</p>

            <p class="dropzone-sub">or click to browse files</p>

            <input #fileInput type="file" accept=".csv,text/csv" style="display:none" (change)="onFileSelected($event)" />

          </div>



          <div *ngIf="parseError" class="bulk-error-box">

            ⚠️ {{ parseError }}

          </div>

        </div>



        <!-- ── STEP 2: Preview table ── -->

        <div *ngIf="parsedRows.length && !uploadResult">

          <div class="bulk-preview-header">

            <div>

              <span class="bulk-preview-count">{{ parsedRows.length }} rows ready to import</span>

              <span class="bulk-preview-file">from <em>{{ selectedFileName }}</em></span>

            </div>

            <button class="btn-secondary" style="font-size:12px;padding:6px 14px" (click)="resetBulk()">â† Change File</button>

          </div>



          <div class="bulk-preview-scroll">

            <table class="bulk-preview-table">

              <thead>

                <tr>

                  <th>#</th>

                  <th>Title</th>

                  <th>Price</th>

                  <th>Category</th>

                  <th>Material</th>

                  <th>Badge</th>

                  <th>In Stock</th>

                </tr>

              </thead>

              <tbody>

                <tr *ngFor="let row of parsedRows; let i = index" [class.row-error]="!row.title || !row.price || !row.category">

                  <td class="row-num">{{ i + 1 }}</td>

                  <td>{{ row.title || '⚠️ Missing' }}</td>

                  <td>{{ row.price ? ('₹' + row.price) : '⚠️ Missing' }}</td>

                  <td>{{ row.category || '⚠️ Missing' }}</td>

                  <td>{{ row.material || '—' }}</td>

                  <td>{{ row.badge || '—' }}</td>

                  <td>{{ row.inStock === 'false' ? 'No' : 'Yes' }}</td>

                </tr>

              </tbody>

            </table>

          </div>



          <div class="bulk-preview-footer">

            <div *ngIf="validRows < parsedRows.length" class="bulk-warn">

              ⚠️ {{ parsedRows.length - validRows }} row(s) have missing required fields and will be skipped.

            </div>

            <div class="bulk-preview-actions">

              <button class="btn-secondary" (click)="resetBulk()" [disabled]="uploading">Cancel</button>

              <button class="btn-gold" id="confirm-bulk-upload-btn" (click)="uploadBulk()" [disabled]="uploading || validRows === 0">

                <span *ngIf="!uploading">

                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">

                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>

                    <polyline points="17 8 12 3 7 8"/>

                    <line x1="12" y1="3" x2="12" y2="15"/>

                  </svg>

                  Upload {{ validRows }} Product{{ validRows !== 1 ? 's' : '' }}

                </span>

                <span *ngIf="uploading">Uploading...</span>

              </button>

            </div>

          </div>

        </div>



        <!-- ── STEP 3: Results ── -->

        <div *ngIf="uploadResult" class="bulk-result">

          <div class="bulk-result-icon" [class.result-success]="uploadResult.created > 0">

            <svg *ngIf="uploadResult.created > 0" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

              <polyline points="20 6 9 17 4 12"/>

            </svg>

            <svg *ngIf="uploadResult.created === 0" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#f87171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>

            </svg>

          </div>

          <h3 class="bulk-result-title">

            {{ uploadResult.created > 0 ? uploadResult.created + ' products added!' : 'No products created' }}

          </h3>

          <p class="bulk-result-sub" *ngIf="uploadResult.errorCount > 0">

            {{ uploadResult.errorCount }} row(s) were skipped due to errors.

          </p>



          <!-- Error details -->

          <div *ngIf="uploadResult.errors?.length" class="bulk-error-list">

            <div *ngFor="let err of uploadResult.errors" class="bulk-error-item">

              <span class="err-row">Row {{ err.row }}</span>

              <span class="err-title">{{ err.title }}</span>

              <span class="err-reason">{{ err.reason }}</span>

            </div>

          </div>



          <div class="bulk-result-actions">

            <button class="btn-gold" (click)="closeBulkModal()">Done</button>

            <button class="btn-secondary" (click)="resetBulk()">Upload Another File</button>

          </div>

        </div>



      </div>

    </div>

  `,

  styles: [`

    /* Filter Bar */

    .filter-bar {

      padding: 14px 20px;

      display: flex;

      align-items: center;

      justify-content: space-between;

      gap: 16px;

      flex-wrap: wrap;

    }



    .search-field {

      position: relative;

      flex: 1;

      min-width: 240px;

    }



    .search-icon {

      position: absolute;

      left: 14px;

      top: 50%;

      transform: translateY(-50%);

      color: var(--text-muted);

      display: flex;

      pointer-events: none;

    }



    .search-input {

      padding-left: 42px;

    }



    .filter-controls {

      display: flex;

      align-items: center;

      gap: 10px;

      flex-wrap: wrap;

    }



    .filter-select {

      width: auto;

      min-width: 160px;

    }



    /* Bulk Upload Button */

    .btn-bulk {

      display: inline-flex;

      align-items: center;

      gap: 7px;

      padding: 9px 16px;

      border-radius: var(--radius-md);

      font-family: var(--font-sans);

      font-size: 12.5px;

      font-weight: 600;

      cursor: pointer;

      border: 1px solid rgba(96, 165, 250, 0.35);

      background: rgba(96, 165, 250, 0.08);

      color: #60a5fa;

      transition: all var(--transition-fast);

    }

    .btn-bulk:hover {

      background: rgba(96, 165, 250, 0.15);

      border-color: rgba(96, 165, 250, 0.55);

    }



    /* Table card */

    .table-card { overflow: hidden; }

    .table-card-header {

      padding: 16px 20px;

      border-bottom: 1px solid var(--border-subtle);

    }



    /* Product cells */

    .product-cell { display: flex; align-items: center; gap: 14px; }

    .product-title { font-size: 13.5px; font-weight: 700; color: var(--text-primary); }

    .product-label { font-size: 10px; color: var(--text-muted); letter-spacing: 0.08em; text-transform: uppercase; margin-top: 1px; }

    .price-block { display: flex; flex-direction: column; gap: 1px; }

    .price-main { font-weight: 700; font-size: 13.5px; color: var(--text-primary); }

    .price-slash { font-size: 11px; color: var(--text-muted); text-decoration: line-through; }

    .accent-cell { display: flex; align-items: center; gap: 8px; }

    .color-swatch { width: 14px; height: 14px; border-radius: 50%; border: 1px solid var(--border-color); display: inline-block; }



    /* Stock toggle */

    .stock-toggle {

      display: inline-flex; align-items: center; gap: 6px;

      padding: 4px 12px 4px 8px; border-radius: var(--radius-full);

      font-family: var(--font-sans); font-size: 11px; font-weight: 700; cursor: pointer;

      border: 1px solid rgba(248,113,113,.25); background: var(--danger-bg); color: var(--danger);

      transition: all var(--transition-fast);

    }

    .stock-toggle.in-stock { border-color: rgba(52,211,153,.25); background: var(--success-bg); color: var(--success); }

    .stock-dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; flex-shrink: 0; }

    .action-group { display: flex; align-items: center; gap: 8px; }



    /* ──â”€ BULK UPLOAD MODAL ──────────────────────────────────────────────â”€ */

    .bulk-backdrop {

      position: fixed; inset: 0;

      background: rgba(0,0,0,0.7);

      backdrop-filter: blur(6px);

      z-index: 1000;

      display: flex; align-items: center; justify-content: center;

      padding: 20px;

    }



    .bulk-modal {

      width: 100%; max-width: 780px;

      max-height: 90vh;

      overflow-y: auto;

      border-radius: var(--radius-lg);

      padding: 28px 28px 24px;

      display: flex;

      flex-direction: column;

      gap: 20px;

      animation: slideUp 0.25s ease;

    }



    @keyframes slideUp {

      from { opacity: 0; transform: translateY(24px); }

      to   { opacity: 1; transform: translateY(0); }

    }



    .bulk-modal-header {

      display: flex; align-items: flex-start; justify-content: space-between;

      padding-bottom: 16px;

      border-bottom: 1px solid var(--border-subtle);

    }

    .bulk-modal-title {

      font-size: 18px; font-weight: 700; color: var(--text-primary);

      display: flex; align-items: center; gap: 10px; margin: 0;

    }

    .bulk-modal-sub { font-size: 12.5px; color: var(--text-muted); margin: 5px 0 0; }

    .bulk-close-btn {

      background: none; border: none; color: var(--text-muted); font-size: 18px;

      cursor: pointer; padding: 2px 6px; line-height: 1;

      border-radius: var(--radius-sm);

      transition: color var(--transition-fast);

    }

    .bulk-close-btn:hover { color: var(--text-primary); }



    /* Template row */

    .bulk-template-row {

      display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;

      padding: 12px 16px;

      background: rgba(212,175,55,0.06);

      border: 1px solid rgba(212,175,55,0.2);

      border-radius: var(--radius-md);

    }

    .bulk-template-label { font-size: 12.5px; color: var(--text-secondary); display: flex; align-items: center; gap: 7px; }

    .btn-template {

      font-size: 12px; font-weight: 600; padding: 7px 14px;

      border-radius: var(--radius-md);

      background: rgba(212,175,55,0.12); color: var(--accent-gold);

      border: 1px solid rgba(212,175,55,0.3);

      cursor: pointer; transition: all var(--transition-fast);

    }

    .btn-template:hover { background: rgba(212,175,55,0.2); }



    /* Column guide */

    .bulk-col-guide {

      background: rgba(255,255,255,0.02);

      border: 1px solid var(--border-subtle);

      border-radius: var(--radius-md);

      padding: 14px 16px;

    }

    .bulk-col-title { font-size: 11.5px; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.07em; margin-bottom: 10px; }

    .bulk-col-grid { display: flex; flex-wrap: wrap; gap: 6px; }

    .bulk-col-chip {

      font-size: 11px; padding: 3px 10px; border-radius: 99px;

      border: 1px solid var(--border-color);

      background: rgba(255,255,255,0.04); color: var(--text-secondary);

    }

    .bulk-col-chip.required { border-color: rgba(212,175,55,0.4); color: var(--accent-gold); background: rgba(212,175,55,0.06); }

    .bulk-note { font-size: 11px; color: var(--text-muted); margin: 10px 0 0; }

    .bulk-note code { background: rgba(255,255,255,0.07); padding: 1px 5px; border-radius: 4px; font-size: 11px; }



    /* Drop zone */

    .bulk-dropzone {

      border: 2px dashed rgba(212,175,55,0.3);

      border-radius: var(--radius-lg);

      padding: 40px 20px;

      text-align: center;

      cursor: pointer;

      transition: all var(--transition-fast);

      display: flex; flex-direction: column; align-items: center;

    }

    .bulk-dropzone:hover, .bulk-dropzone.drag-over {

      border-color: var(--accent-gold);

      background: rgba(212,175,55,0.05);

    }

    .dropzone-label { font-size: 15px; font-weight: 600; color: var(--text-primary); margin: 0 0 4px; }

    .dropzone-sub { font-size: 12px; color: var(--text-muted); margin: 0; }



    .bulk-error-box {

      background: var(--danger-bg); border: 1px solid rgba(248,113,113,.25);

      color: var(--danger); padding: 10px 14px; border-radius: var(--radius-md);

      font-size: 13px;

    }



    /* Preview */

    .bulk-preview-header {

      display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px;

      padding: 12px 16px;

      background: rgba(255,255,255,0.03);

      border: 1px solid var(--border-subtle);

      border-radius: var(--radius-md);

    }

    .bulk-preview-count { font-size: 14px; font-weight: 700; color: var(--accent-gold); }

    .bulk-preview-file { font-size: 12px; color: var(--text-muted); margin-left: 8px; }

    .bulk-preview-scroll { max-height: 280px; overflow-y: auto; border: 1px solid var(--border-subtle); border-radius: var(--radius-md); }



    .bulk-preview-table { width: 100%; border-collapse: collapse; font-size: 12px; }

    .bulk-preview-table th {

      padding: 8px 12px; text-align: left; font-size: 10.5px; font-weight: 700;

      text-transform: uppercase; letter-spacing: 0.06em; color: var(--text-muted);

      background: rgba(0,0,0,0.25); position: sticky; top: 0;

      border-bottom: 1px solid var(--border-subtle);

    }

    .bulk-preview-table td {

      padding: 8px 12px; color: var(--text-secondary);

      border-bottom: 1px solid var(--border-subtle);

    }

    .bulk-preview-table tr:last-child td { border-bottom: none; }

    .bulk-preview-table tr.row-error td { background: rgba(248,113,113,0.06); color: var(--danger); }

    .row-num { font-size: 10px; color: var(--text-muted); font-weight: 700; }



    .bulk-preview-footer {

      display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;

      padding-top: 4px;

    }

    .bulk-preview-actions { display: flex; gap: 10px; }

    .bulk-warn { font-size: 12px; color: #fbbf24; }



    /* Result */

    .bulk-result {

      display: flex; flex-direction: column; align-items: center;

      text-align: center; gap: 14px; padding: 20px 0 8px;

    }

    .bulk-result-icon {

      width: 64px; height: 64px; border-radius: 50%;

      background: rgba(248,113,113,0.1);

      display: flex; align-items: center; justify-content: center;

    }

    .bulk-result-icon.result-success { background: rgba(34,197,94,0.1); }

    .bulk-result-title { font-size: 20px; font-weight: 700; color: var(--text-primary); margin: 0; }

    .bulk-result-sub { font-size: 13px; color: var(--text-muted); margin: 0; }



    .bulk-error-list {

      width: 100%; max-height: 180px; overflow-y: auto;

      border: 1px solid var(--border-subtle); border-radius: var(--radius-md);

      text-align: left;

    }

    .bulk-error-item {

      display: grid; grid-template-columns: 60px 1fr 2fr;

      gap: 8px; padding: 8px 14px;

      border-bottom: 1px solid var(--border-subtle);

      font-size: 12px;

    }

    .bulk-error-item:last-child { border-bottom: none; }

    .err-row { color: var(--text-muted); font-weight: 700; }

    .err-title { color: var(--text-primary); }

    .err-reason { color: var(--danger); }



    .bulk-result-actions { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }



    /* Thumb box & multi-image strip */

    .thumb-box {

      width: 48px;

      height: 48px;

      border-radius: var(--radius-sm);

      display: flex;

      align-items: center;

      justify-content: center;

      overflow: hidden;

      flex-shrink: 0;

      position: relative;

      cursor: pointer;

      border: 1px solid var(--border-subtle);

      transition: all var(--transition-fast);

    }

    .thumb-box.has-multi:hover {

      transform: scale(1.05);

      border-color: var(--accent-gold);

    }

    .thumb-box img {

      width: 100%;

      height: 100%;

      object-fit: cover;

    }

    .img-count-badge {

      position: absolute;

      bottom: 2px;

      right: 2px;

      background: rgba(0,0,0,0.75);

      color: var(--accent-gold);

      font-size: 9px;

      font-weight: 700;

      padding: 1px 4px;

      border-radius: 4px;

      line-height: 1.2;

      border: 1px solid rgba(212,175,55,0.4);

    }

    .image-strip {

      display: flex;

      align-items: center;

      gap: 4px;

      margin-top: 4px;

    }

    .strip-img {

      width: 22px;

      height: 22px;

      border-radius: 3px;

      object-fit: cover;

      border: 1px solid var(--border-subtle);

    }

    .strip-primary {

      border-color: var(--accent-gold);

    }

    .strip-more {

      font-size: 10px;

      color: var(--text-muted);

      font-weight: 600;

      padding-left: 2px;

    }



    /* Image Lightbox */

    .img-lightbox-backdrop {

      position: fixed; inset: 0;

      background: rgba(0,0,0,0.85);

      backdrop-filter: blur(8px);

      z-index: 1200;

      display: flex; align-items: center; justify-content: center;

      padding: 24px;

    }

    .img-lightbox-modal {

      width: 100%; max-width: 580px;

      background: #0d131f;

      border: 1px solid var(--border-subtle);

      border-radius: var(--radius-lg);

      padding: 24px;

      display: flex; flex-direction: column; gap: 18px;

    }

    .lightbox-header {

      display: flex; justify-content: space-between; align-items: flex-start;

    }

    .lightbox-header h3 { font-size: 18px; margin: 0; color: var(--text-primary); }

    .lightbox-sub { font-size: 12px; color: var(--accent-gold); text-transform: uppercase; letter-spacing: 0.05em; }

    .lightbox-close-btn {

      background: none; border: none; font-size: 20px; color: var(--text-muted);

      cursor: pointer; padding: 4px 8px; border-radius: 4px;

      transition: color var(--transition-fast);

    }

    .lightbox-close-btn:hover { color: #fff; }

    .lightbox-main-view {

      position: relative; display: flex; align-items: center; justify-content: center;

      min-height: 320px; max-height: 420px;

    }

    .lightbox-img-wrapper {

      width: 100%; height: 340px; display: flex; align-items: center; justify-content: center;

      border-radius: var(--radius-md); overflow: hidden; border: 1px solid var(--border-subtle);

    }

    .lightbox-active-img {

      max-width: 100%; max-height: 100%; object-fit: contain;

    }

    .lightbox-nav-btn {

      position: absolute; top: 50%; transform: translateY(-50%);

      width: 38px; height: 38px; border-radius: 50%;

      background: rgba(0,0,0,0.65); border: 1px solid rgba(255,255,255,0.15);

      color: #fff; font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center;

      transition: all var(--transition-fast); z-index: 10;

    }

    .lightbox-nav-btn:hover { background: var(--accent-gold); color: #000; border-color: var(--accent-gold); }

    .prev-btn { left: 8px; }

    .next-btn { right: 8px; }

    .lightbox-thumbs {

      display: flex; gap: 8px; overflow-x: auto; padding: 4px 2px;

    }

    .lightbox-thumb {

      width: 56px; height: 56px; border-radius: var(--radius-sm);

      overflow: hidden; flex-shrink: 0; cursor: pointer;

      border: 2px solid transparent; opacity: 0.6; transition: all var(--transition-fast);

    }

    .lightbox-thumb.active {

      border-color: var(--accent-gold); opacity: 1;

    }

    .lightbox-thumb img { width: 100%; height: 100%; object-fit: cover; }
  `]

})

export class ProductListComponent implements OnInit {

  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;



  products: Product[] = [];
  categories: Category[] = [];
  availableSubCategories: SubCategory[] = [];
  searchQuery = '';
  selectedCategory = 'all';
  selectedSubCategory = 'all';
  selectedSort = 'newest';
  totalProducts = 0;

  currentPage = 1;
  totalPages = 1;
  pageSize = 25;
  pageSizeOptions = [25, 50, 100];
  loading = false;
  private searchTimer: ReturnType<typeof setTimeout> | null = null;



  // ── Bulk Upload State ────────────────────────────────────────────────



  // ── Image Lightbox ─────────────────────────────

  previewProduct: Product | null = null;

  activePreviewIndex = 0;



  openImagePreview(product: Product): void {

    const images = this.getProductImages(product);

    if (images.length === 0) return;

    this.previewProduct = product;

    this.activePreviewIndex = 0;

  }



  closeImagePreview(): void {

    this.previewProduct = null;

    this.activePreviewIndex = 0;

  }



  setPreviewIndex(idx: number): void {

    this.activePreviewIndex = idx;

  }



  prevPreviewImage(): void {

    const imgs = this.getPreviewImages();

    if (imgs.length <= 1) return;

    this.activePreviewIndex = (this.activePreviewIndex - 1 + imgs.length) % imgs.length;

  }



  nextPreviewImage(): void {

    const imgs = this.getPreviewImages();

    if (imgs.length <= 1) return;

    this.activePreviewIndex = (this.activePreviewIndex + 1) % imgs.length;

  }



  getPreviewImages(): string[] {

    return this.previewProduct ? this.getProductImages(this.previewProduct) : [];

  }



  getProductImages(product: Product): string[] {

    const list: string[] = [];

    if (product.images && product.images.length > 0) {

      product.images.forEach(img => { if (img.url) list.push(img.url); });

    }

    if (list.length === 0 && product.imageUrl) {

      list.push(product.imageUrl);

    }

    return list;

  }



  bulkModalOpen = false;

  isDragOver = false;

  selectedFileName = '';

  parsedRows: any[] = [];

  parseError = '';

  uploading = false;

  uploadResult: { created: number; errorCount: number; errors: any[] } | null = null;



  get validRows(): number {

    return this.parsedRows.filter(r => r.title && r.price && r.category).length;

  }



  constructor(
    private productService: ProductService,
    private categoryService: CategoryService,
    private subCategoryService: SubCategoryService
  ) {}

  ngOnInit(): void {
    this.loadCategories();
    this.loadSubCategories();
    this.loadProducts();
  }

  loadCategories(): void {
    this.categoryService.getCategories().subscribe({
      next: (res) => (this.categories = res),
      error: (err) => console.error(err)
    });
  }

  loadSubCategories(): void {
    const cat = this.selectedCategory !== 'all' ? this.selectedCategory : undefined;
    this.subCategoryService.getSubCategories(cat).subscribe({
      next: (res) => (this.availableSubCategories = res),
      error: (err) => console.error(err)
    });
  }

  onCategoryFilterChange(): void {
    this.selectedSubCategory = 'all';
    this.currentPage = 1;
    this.loadSubCategories();
    this.loadProducts();
  }

  loadProducts(): void {
    this.loading = true;
    this.productService
      .getProducts({
        category: this.selectedCategory !== 'all' ? this.selectedCategory : undefined,
        subCategory: this.selectedSubCategory !== 'all' ? this.selectedSubCategory : undefined,
        search: this.searchQuery?.trim() || undefined,
        sort: this.selectedSort,
        page: this.currentPage,
        limit: this.pageSize
      })
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.products = res.products || [];
          this.totalProducts = res.total || 0;
          this.totalPages = res.pages || Math.ceil(this.totalProducts / this.pageSize) || 1;
          if (this.currentPage > this.totalPages && this.totalPages > 0) {
            this.currentPage = this.totalPages;
            this.loadProducts();
          }
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
        }
      });
  }

  onFilterChange(): void {
    this.currentPage = 1;
    this.loadProducts();
  }

  onSearchInput(): void {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.currentPage = 1;
      this.loadProducts();
    }, 300);
  }

  getStartIndex(): number {
    if (this.totalProducts === 0) return 0;
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  getEndIndex(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalProducts);
  }

  goToPage(page: number | string): void {
    if (typeof page !== 'number') return;
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    this.loadProducts();
    this.scrollToTop();
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadProducts();
      this.scrollToTop();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadProducts();
      this.scrollToTop();
    }
  }

  onPageSizeChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const newSize = Number(select?.value) || 25;
    if (newSize !== this.pageSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.loadProducts();
    }
  }

  getPageNumbers(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages: (number | string)[] = [];
    pages.push(1);

    let start = Math.max(2, current - 1);
    let end = Math.min(total - 1, current + 1);

    if (current <= 3) {
      end = 4;
    } else if (current >= total - 2) {
      start = total - 3;
    }

    if (start > 2) {
      pages.push('...');
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < total - 1) {
      pages.push('...');
    }

    pages.push(total);
    return pages;
  }

  private scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }



  toggleStock(product: Product): void {

    if (!product._id) return;

    const newStock = !product.inStock;

    this.productService.updateProduct(product._id, { inStock: newStock }).subscribe({

      next: () => { product.inStock = newStock; },

      error: (err) => alert('Failed to update stock: ' + err.message)

    });

  }



  deleteProduct(product: Product): void {

    if (!product._id) return;

    if (confirm(`Are you sure you want to delete "${product.title}"?`)) {

      this.productService.deleteProduct(product._id).subscribe({

        next: () => {

          this.products = this.products.filter((p) => p._id !== product._id);

          this.totalProducts--;

        },

        error: (err) => alert('Failed to delete product: ' + err.message)

      });

    }

  }



  // ── Bulk Upload Methods ──────────────────────────────────────────────



  openBulkModal(): void {

    this.bulkModalOpen = true;

    this.resetBulk();

  }



  closeBulkModal(): void {

    this.bulkModalOpen = false;

    if (this.uploadResult?.created) {

      this.loadProducts(); // Refresh list if products were added

    }

    this.resetBulk();

  }



  resetBulk(): void {

    this.parsedRows = [];

    this.parseError = '';

    this.uploading = false;

    this.uploadResult = null;

    this.selectedFileName = '';

    this.isDragOver = false;

  }



  onFileSelected(event: Event): void {

    const file = (event.target as HTMLInputElement).files?.[0];

    if (file) this.handleFile(file);

  }



  onFileDrop(event: DragEvent): void {

    event.preventDefault();

    this.isDragOver = false;

    const file = event.dataTransfer?.files[0];

    if (file) this.handleFile(file);

  }



  handleFile(file: File): void {

    this.parseError = '';

    if (!file.name.endsWith('.csv')) {

      this.parseError = 'Please upload a valid .csv file.';

      return;

    }

    this.selectedFileName = file.name;

    const reader = new FileReader();

    reader.onload = (e) => {

      const text = e.target?.result as string;

      this.parseCSV(text);

    };

    reader.readAsText(file);

  }



  parseCSV(text: string): void {

    const lines = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.trim());

    if (lines.length < 2) {

      this.parseError = 'CSV file is empty or has no data rows.';

      return;

    }



    const headers = lines[0].split(',').map(h => h.trim().toLowerCase().replace(/\s+/g, ''));

    const required = ['title', 'price', 'category'];

    const missing = required.filter(r => !headers.includes(r));

    if (missing.length > 0) {

      this.parseError = `Missing required columns: ${missing.join(', ')}. Please use the template.`;

      return;

    }



    const rows: any[] = [];

    for (let i = 1; i < lines.length; i++) {

      const values = this.splitCSVLine(lines[i]);

      if (values.every(v => !v.trim())) continue; // skip blank lines

      const row: any = {};

      headers.forEach((h, idx) => { row[h] = values[idx]?.trim() || ''; });

      rows.push(row);

    }



    if (rows.length === 0) {

      this.parseError = 'No data rows found in file.';

      return;

    }

    if (rows.length > 500) {

      this.parseError = 'Max 500 rows per upload. Please split your file.';

      return;

    }



    this.parsedRows = rows;

  }



  // Handles quoted CSV values

  splitCSVLine(line: string): string[] {

    const result: string[] = [];

    let current = '';

    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {

      const ch = line[i];

      if (ch === '"') {

        inQuotes = !inQuotes;

      } else if (ch === ',' && !inQuotes) {

        result.push(current);

        current = '';

      } else {

        current += ch;

      }

    }

    result.push(current);

    return result;

  }



  uploadBulk(): void {

    if (this.uploading || this.validRows === 0) return;

    this.uploading = true;

    this.productService.bulkCreateProducts(this.parsedRows).subscribe({

      next: (res) => {

        this.uploading = false;

        this.uploadResult = { created: res.created, errorCount: res.errorCount, errors: res.errors || [] };

      },

      error: (err) => {

        this.uploading = false;

        this.uploadResult = { created: 0, errorCount: this.parsedRows.length, errors: [{ row: '–', title: '–', reason: err.message || 'Upload failed' }] };

      }

    });

  }



  downloadTemplate(): void {

    const headers = 'title,price,slashPrice,category,material,badge,description,imageUrl,label,icon,bg,inStock,featured,deviceModels';

    const sample = '"Ferrari GT3 Phone Case",555,666,porsche,"Hard & Glass Armor",Sale,"Luxury handcrafted UV printed case","",SHELL MUZE,ðŸŽï¸,#18181B,true,false,"iPhone 16 Pro|Samsung S24 Ultra"';

    const csvContent = `${headers}\n${sample}`;

    const blob = new Blob([csvContent], { type: 'text/csv' });

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');

    a.href = url;

    a.download = 'shell-muze-products-template.csv';

    a.click();

    URL.revokeObjectURL(url);

  }

}

